/**
 * Convert a phone number into `(888) 888-8888` format.
 * If the number is already in that format, it will stay in that format.
 * If the number is invalid or cannot be reformatted, it will be returned unchanged.
 * @param {string} unformattedNumber - the phone number to convert.
 * @returns string - the formatted phone number
 */
export const formatPhoneNumber = (unformattedNumber, altFormat = false) => {
    const digits = unformattedNumber.replace(/\D/g, '');
    if(digits.length === 10) {
      if(altFormat){
        return `${digits.substring(0, 3)}-${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
      } else {
        return `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
      }
    }
  
    return unformattedNumber;
};

/**
 * Convert an array of ringpools to an object which maps ringpool ids to phone numbers.
 * @param ringpools - array of ringpool objects as returned by `getNumberForRingpools`
 * @see {link getNumberForRingpools}
 * @returns {Object} - keys are ringpool ids, values are phone numbers
 */
export function ringpoolsToMap(ringpools) {
  let mappedRingpools = {};

  ringpools.forEach(ringpool => {
    const rpid = ringpool.rpid;
    const tfn = ringpool.tfn;
    
    if(typeof(mappedRingpools[rpid.toString()]) === 'undefined') {
      mappedRingpools[rpid.toString()] = tfn;
    }
  });

  return mappedRingpools;
}

/**
 * Decode an obfuscated number from the Ring Center API into basic ASCII.
 * @param encodedNumber
 * @returns {String} - the phone number in plaintext
 */
export function decodeNumber(encodedNumber) {
  return encodedNumber.replace(/&#(\d+);/g, function(match, dec) {
    return String.fromCharCode(dec);
  }).replace(/\u200b/g, '');
}